module.exports = __webpack_public_path__ + "static/media/thumbnail.0dc68150.jpg";